<!--
@Author: Calvin Green <calvin>
@Date:   2021-11-08T10:04:52+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-05-12T20:30:03+02:00
@Copyright: Diversitude 2022
-->



<template>
    <div>

        <b-card>
            <div class="d-flex flex-wrap" style="width: 100%;">
                <div class="card-title">
                    Clients
                </div>
                <b-button @click="showApplicantModal()" class="ms-auto mb-2" variant="outline-primary">
                    + New Applicant
                </b-button>
                <!--<b-dropdown class="ms-auto mb-1" variant="light" toggle-tag="a" menu-class="dropdown-menu-end"  right>
                    <template #button-content>
                            <i class="fas fa-bars"></i>&nbsp; &nbsp; Actions
                    </template>
                    <b-dropdown-item @click="showApplicantModal()" href="#">+ New Applicant</b-dropdown-item>
                </b-dropdown>-->
            </div>
            <webix-ui v-if="clients != null" :config="config" v-model="clients_data"></webix-ui>
        </b-card>
        <ApplicantModal v-if="show_applicant_modal"/>
    </div>
</template>

<script>
import ApplicantModal from '@/components/admin/applicantModal.vue';
import { ccbAdminState, ccbAdminMethods } from "@/state/helpers"
//eslint-disable-next-line
import { parseISO, format } from 'date-fns';
import _ from 'lodash';
export default {
    components:{
        ApplicantModal,
    },
    data:() => ({
        show_applicant_modal: false,
        config:{
            view: 'datatable',
            css: "datatableApplicants",
            select: 'row',
            hover: 'row-hover',
            autoheight: true,
            fillspace: true,
            data:[],
            columns:[
                { id: 'id', header:'', hidden: true},
                { id: 'client_name', header:'Applicants', fillspace: true},
                { id: 'licensing', header:'Licensing', fillspace: 0.45},
                { id: 'signup_date', header:'Signup Date', fillspace: 0.5},
                { id: 'qms_expiry_date', header:'Expiry Date', fillspace: 0.5},
                { id: 'contact_person', header:'Contact Contact', fillspace: 0.5},
                // { id: 'status', header:'Status', fillspace: 0.5},
                //eslint-disable-next-line
                { id: 'actions', header:'', fillspace: 0.2, template(obj, common, value){
                    let element = '<div style="text-align: center;">';
                    if(obj.action_required){
                        element += '<span class="webix_icon_hover webix_icon question_icon far fa-question-circle"></span>&nbsp;'
                    }
                    if(obj.comments){
                        element += '<span class="webix_icon_hover webix_icon comment_icon far fa-comment"></span>&nbsp;'
                    }
                    /*
                    other icons
                    */
                    element += '</div>';
                    return element;
                }
                /*'<div style="text-align: center;">'+
                '<span class="webix_icon_hover webix_icon comment_icon far fa-comment"></span>&nbsp;'+
                '<span class="webix_icon_hover webix_icon question_icon far fa-question-circle"></span>&nbsp;'+
                '<span class="webix_icon_hover webix_icon bell_icon far fa-bell"></span></div>'*/}
            ],
            on:{//eslint-disable-next-line
                onItemClick(id, e, node){
                    var el = this.$scope.$parent;
                    if(el.clickedAction == false){
                        el.selectRow(id.row);
                    }
                }
            },
        },
        //used to check if user clicked row or action button
        clickedAction: false,
    }),
    computed:{
        ...ccbAdminState,
        clients_data(){
            if(this.clients != null){
                let clients = _.cloneDeep(this.clients);
                clients.forEach((client) => {
                    client.signup_date = format(parseISO(client.signup_date), 'dd MMM yyyy');
                    client.qms_expiry_date = format(parseISO(client.qms_expiry_date), 'dd MMM yyyy');
                    let status = client.status.replace('%','');
                    client.status = Math.floor(Number(status)) + '%';
                })
                return clients;
            }
            else{ return [] }
        },
    },
    methods:{
        ...ccbAdminMethods,
        selectRow(id){
            this.$emit('selectedRow', id);
        },
        /*testClient(){
            let params = {
                company_name: 'Test 3',
                contact_person: 'Tester',
                company_phone: '1234567000',
                company_email: 'test2@testemail2.com',
                company_address: '123 Test Lane',
            }
            this.addClient(params)
        },
        refreshClients(){
            this.loadClients();
        },*/
        showApplicantModal(){
            this.show_applicant_modal = true;
            this.$nextTick(()=>{
                this.$bvModal.show('applicantModal');
            })
        }
    },
    mounted(){},
}
</script>

<style>
.comment_icon{
    color: dodgerblue;
}
.question_icon{
    color: red;
}
.bell_icon{
    color: dodgerblue;
}
.row-hover{
    background: #bbbbbb5d;
}
</style>
